////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import { isUndefined } from 'lodash'

//////STYLED//////
const UsersManagerRoleComponentWrapper = styled.div``
//////STYLED//////

const UsersManagerRoleComponent = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<UsersManagerRoleComponentWrapper>{!isUndefined(props.row) && translations[props.row.role.translationKey]}</UsersManagerRoleComponentWrapper>
	)
}

UsersManagerRoleComponent.propTypes = {}

UsersManagerRoleComponent.defaultPropTypes = {}

export default UsersManagerRoleComponent
